import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.lead.index'),
        name: 'lead.index',
        component: () =>
            import(/* webpackChunkName: "leads" */ '@/views/leads/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.lead.breadcrumb.index'),
                    to: { name: 'lead.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.lead.edit') + '/:id',
        name: 'lead.edit',
        component: () =>
            import(/* webpackChunkName: "leads" */ '@/views/leads/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.lead.breadcrumb.index'),
                    to: { name: 'lead.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.lead.breadcrumb.edit'),
                    to: { name: 'lead.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
